import { render } from "./SiteNavigationMobile.vue?vue&type=template&id=50fb7a86"
import script from "./SiteNavigationMobile.vue?vue&type=script&lang=js"
export * from "./SiteNavigationMobile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__